module.exports = __webpack_public_path__ + "1beb4dea6c18dd8c410bf9d06217aa35.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo-inverse.svg
// module id = 403
// module chunks = 1